import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './translations/en.json';
import zhTranslations from './translations/zh.json';

// Get language from localStorage if it exists
const savedLanguage = localStorage.getItem('i18nextLng');
const browserLanguage = navigator.language;
const preferredLanguage = savedLanguage || 
                          (browserLanguage.startsWith('zh') ? 'zh' : 'en');

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: enTranslations
            },
            zh: {
                translation: zhTranslations
            }
        },
        fallbackLng: 'en',
        lng: preferredLanguage, // Use the determined preferred language
        interpolation: {
            escapeValue: false
        },
        detection: {
            order: ['localStorage', 'navigator'],
            lookupLocalStorage: 'i18nextLng',
            caches: ['localStorage']
        }
    });

// Set HTML lang attribute to match the current language
document.documentElement.setAttribute('lang', i18n.language);

export default i18n; 